$(function(){

	$(document).on('show.bs.modal', function () {
		$('.modal .modal-body').css('overflow-y', 'auto'); 
		$('.modal .modal-body').css('max-height', $(window).height() * 0.7);
	});

	$(document).on('shown.bs.modal', function () {
		// Lorsqu'on ouvre une fenêtre modal, on recherche le premier champ disponible et on lui donne le focus
		// Si c'est le popup pour entrer un temps via la grille de saisie
		if ($(this).find(".modal").hasClass("work-input-grid-modal")) {
			$("input[name=work_time]").trigger("select"); // On met le focus sur le champs Temps
		} else {
			$('.modal-body form:not(.filter) :input:not([readonly]):visible:enabled:first:not(.no-focus)').trigger("focus")
		}
	});

	// Début validation email
	jQuery.validator.addMethod("email2", function (value, element) {
		var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return value.trim() == "" || regex.exec(value) !== null;
	});
	// Fin validation email

	// Début validation step15
	jQuery.validator.addMethod("step15", function (value, element) {
		value = parseInt(value);
		return value % 15 == 0;
	});
	// Fin validation step15

	// Début validation step15
	jQuery.validator.addMethod("joinedHasEstimated", function (value, element) {
    var refElement = $($(element).attr("reference"));
		return !(value == "1" && !refElement.prop("checked"))
	});
	// Fin validation step15

	addJQueryCompareMethods();
});

//$(document).ajaxStart(function() { Pace.restart(); });
//$(document).submit(function() { Pace.restart(); });

$(document).on('keydown', function(ev){
	if(ev.key == 's' && ev.ctrlKey){
		var elem = $("[data-bb-handler=save]").last();
		if(elem.length > 0){
			ev.preventDefault();
			elem.trigger('click');
		}
	}
})

// comparer les dates avec moment.js
window.addJQueryCompareDateMethods = function(date_placeholder_format) {
	date_placeholder_format = date_placeholder_format.toUpperCase();
	jQuery.validator.addMethod("greaterOrEqualToDate", function (value, element, params) {
		value = moment(value, date_placeholder_format).format("YYYY-MM-DD");
		params = moment($(params).val(), date_placeholder_format).format("YYYY-MM-DD");
		if (!/Invalid|NaN/.test(new Date(value)) && !/Invalid|NaN/.test(new Date(params))) {
			return new Date(value) >= new Date(params);
		}
		return true;
	}, "Date n'est pas valide");

	jQuery.validator.addMethod("smallerOrEqualToDate", function (value, element, params) {
		value = moment(value, date_placeholder_format).format("YYYY-MM-DD");
		params = moment($(params).val(), date_placeholder_format).format("YYYY-MM-DD");
		if (!/Invalid|NaN/.test(new Date(value)) && !/Invalid|NaN/.test(new Date(params))) {
			return new Date(value) <= new Date(params);
		}
		return true;
	}, "Date n'est pas valide");
}

// comparer les nombres
window.addJQueryCompareMethods = function() {
	jQuery.validator.addMethod("greaterOrEqualTo", function (value, element, params) {
		params = $(params).val();
		return isNaN(value) && isNaN(params) || (Number(value) >= Number(params));
	}, "Nombre n'est pas valide");

	jQuery.validator.addMethod("smallerOrEqualTo", function (value, element, params) {
		params = $(params).val();
		return isNaN(value) && isNaN(params) || (Number(value) <= Number(params));
	}, "Nombre n'est pas valide");
}

const saveChangeListener = () => {
  return "Save changes?";
};

// prévenir la fermeture d'onglet
var hasUnsavedChanges = false;
window.toggleWarn = function(b){
	hasUnsavedChanges = b;
	if(b){
    window.addEventListener("beforeunload", saveChangeListener)
	}
	else{
    window.removeEventListener("beforeunload", saveChangeListener);
	}
}

var randomBrowserId = window.randomBrowserId = parseInt(Math.random() * 10000000000);

$.ajaxSetup({
  beforeSend: function(xhr) {
    xhr.setRequestHeader('X-Browser-Id', randomBrowserId);
  }
})

// rediriger vers la page de login si pas de session
$(document).ajaxComplete(function (event, xhr, settings) {
	var res = xhr.responseText;
	if (res != undefined && res.length > 0 && res.charAt(0) == "{") {
		var json = JSON.parse(res);
		if (json.session_died != null && json.session_died == 1) {
			$("body").html("");
			var redirection_path = json.redirect_path;
			window.location.href = redirection_path;
		}
	}
});

// Fonction pour rafraichir une datatable
window.refreshTable = function(selector, html) {
	$(selector).html(html);
	$(selector + " .tooltips").tooltip(); 
	if ($(selector).hasClass("scroller")) {
		var max_height = $(selector).css("max-height");
		App.destroySlimScroll($(selector));
		$(selector).css("max-height", max_height);
		App.initSlimScroll($(selector));
	}
  
	if ($(selector).closest(".portlet").find(".nav-tabs").length == 0) {
		var row = $(selector).parents("div.row").last();
		adjustPortletsHeights(row);	
	}
}

// Fonction pour ajuster la hauteur des bo�tes (portlets) d'une m�me ligne (row), on prend la hauteur maximale
window.adjustPortletsHeights = function(rows) {
	var rows = rows || $("body").find("div.row");
	// On trouve toutes les lignes qui contiennent au moins deux portlets
	rows.filter(function() { return $(this).find("div.portlet").length > 1; }).each(function() {
		// On commence par r�initialiser la hauteur du portlet
		$(this).find("div.portlet").css("height", "auto");		
		// On trouve la hauteur maximale entre les divs enfants
		var max_height = Math.max.apply(null, $(this).find("div.portlet").map(function () { return $(this).height(); }).get());
		$(this).find("div.portlet").css("height", max_height); // On change la hauteur pour que tous les portlets de la m�me row aient la m�me hauteur
	});
}

// fonction pour unifier les bootbox de confirmation
window.customBootboxConfirmation = function(main_title,title,explication,question,buttons,class_name){
	var title_content = "<div class='bootbox-main-title'>"+main_title+"</div>";
	var message_content = "<div class='bootbox-content-title'>"+title+"</div>";
	message_content += "<div class='bootbox-content-message'>"+explication+"</div>";
	message_content += "<div class='bootbox-content-question'>"+question+"</div>";
	var my_bootbox = bootbox.dialog({ 
		className: class_name,
		title: title_content,
		message: message_content,
		buttons: buttons
	});

	my_bootbox.on("shown.bs.modal", function() {
		var modal_body = $("."+class_name).find(".modal-body");
		var modal_body_height = modal_body.height();

		var height_title = modal_body.find(".bootbox-content-title").height();
		var height_message = modal_body.find(".bootbox-content-message").height();
		var height_question = modal_body.find(".bootbox-content-question").height();

		// limiter l'hauteur visible de l'explication si trop grande
		var height_visible_min = 60;
		var height_visible = height_message;
		if ((height_title + height_message + height_question) > modal_body_height) {
			if ((height_title + height_question + height_visible_min) > modal_body_height) {
				height_visible = height_visible_min;
			}
			else{
				height_visible = modal_body_height - (height_title + height_question);
			}
		}
		// afficher la partie avec la question
		modal_body.scrollTop(height_title + height_visible + height_question);
		modal_body.find(".bootbox-content-message").css("height",height_visible+"px");

	});

}

// fonction pour initialiser les footables
window.initFootable = function(tableSelector, breakpoints) {
	var empty_msg = $(tableSelector).data("footable-empty-message");
	if (typeof empty_msg === "undefined" || empty_msg === null) {
		empty_msg = "Aucun résultat";
	}
	if (breakpoints != "") {
		$(tableSelector).footable({ "breakpoints": breakpoints, "empty": empty_msg });
	}
	else {
		$(tableSelector).footable({
			"breakpoints": {
				"xs": 480, // extra small
				"sm": 768, // small
				"md": 992, // medium
				"lg": 1200, // large
				"xlg": 1400, // x-large
				"xxlg": 1600 // x-large
			},
			"empty": empty_msg
		});
	}
	$(tableSelector + " .tooltips").tooltip();
}

// fonction pour mettre � jour la ligne dans une table
window.refreshTableTr = function(id_table,id_tr,tr,footable_breakpoints){
	$("#"+id_table).find("tr.selected").removeClass("selected");

	if ($("#"+id_table).hasClass("footable")) {
		var y = window.pageYOffset;	
		var expanded = $("#"+id_tr).data("expanded");
		$("#"+id_tr).replaceWith(tr);
		initFootable("#"+id_table,footable_breakpoints);
		initDescriptionCells(id_table);
		window.scrollTo(0, y);
		if (expanded == true) {
			// d�velopper la ligne de footable
			$("#"+id_tr).trigger('click');
		}
	}
	else{
		$("#"+id_tr).replaceWith(tr);
		initDescriptionCells(id_table);
	}
}

// fonction pour afficher/cacher le contenu des cellules dans les tables
window.initDescriptionCells = function(id_table){
	$("#"+id_table).find(".td-description").each(function(){
		var content = $(this).html();
		var max_height = $(this).data("max-height");
		if (content != "") {
			var height = $(this).outerHeight();
			if (height >= max_height) {
				var container = $("#tpl_description").clone();
				container.css("height",max_height+"px");
				container.removeAttr("id");
				container.find(".description-content").append(content);
				$(this).html(container);
				$(this).find(".tooltips").tooltip();
			}
		}
	});

	$("#"+id_table).off("click",".action-description-show");
	$("#"+id_table).on("click",".action-description-show",function(){
		$(this).fadeOut(function(){
			var descr = $(this).closest(".description-container");
			descr.find(".action-description-hide").fadeIn();
			var cont_height = descr.find(".description-content").height();
			descr.animate({ height:cont_height });		
		});
	});
	$("#"+id_table).off("click",".action-description-hide");
	$("#"+id_table).on("click",".action-description-hide",function(){
		$(this).fadeOut(function(){
			var descr = $(this).closest(".description-container");
			var max_height = $(this).closest(".td-description").data("max-height");
			descr.find(".action-description-show").fadeIn();
			descr.animate({ height:max_height });		
		});
	});
}

/**
 * Fonction pour traiter l'erreur AJAX/XHR.
 */
window.processXHRError = function(jqXHR, textStatus, thrownErr) {
	if (!thrownErr || typeof thrownErr !== 'string' || !thrownErr || thrownErr.length>200){
		console.log(thrownErr);
		thrownErr = "Erreur";
	}
	if (jqXHR.status === 400) {
		var resp_text;
		try {
			resp_text = JSON.parse(jqXHR.responseText);
		} catch(e) {
			// Strip PHP/xdebug HTML appended after JSON (e.g. "{ ... }<br/><font...>")
			var clean = jqXHR.responseText ? jqXHR.responseText.replace(/<[\s\S]*$/, '').trim() : '';
			try { resp_text = JSON.parse(clean); } catch(e2) { resp_text = { field: 'form', msg: clean || 'Erreur serveur' }; }
		}
		if(resp_text.field == "form"){
			$(".form-error-card").show();
			$(".form-error-msg").text(resp_text.msg);
			toastr.error(resp_text.msg, thrownErr);
		} else if(resp_text.message != undefined){
			toastr.error(resp_text.message);
    } else{
			toastr.error(resp_text.msg, thrownErr);
		}
	}
	else {
		if (!jqXHR.responseText || typeof jqXHR.responseText !== 'string' || jqXHR.responseText.length>300) { 
			console.log(jqXHR.responseText);
			jqXHR.responseText = "Une erreur est survenue sur le serveur.";
		}
		toastr.error(jqXHR.responseText, thrownErr);
	}
}

/**
 * Fonction pour traiter le popup selon la réponse du serveur.
 */
window.processPopupServerResponse = function(bootboxPopup, success) {
	if (success) {
		bootboxPopup.modal('hide');
	}
	else {
		$(".submit-btn").prop("disabled", false);
		$(".submit-btn").removeClass("disabled");
	}
}

$(document).on("mousemove", ".select2-results__option", function(e) {
  var offset = $(".modal-dialog").offset();
  if(offset !== undefined){
    $(this).find(".hover-bubble").css("left", (e.pageX-offset.left+20)+"px");
    $(this).find(".hover-bubble").css("top", (e.pageY-offset.top-5)+"px");
  }
});

$.fn.encryptFieldNames = function(){
	$(this).find("input").each(function(){
		if($(this).attr("name") != null){
			$(this).data("original-name", $(this).attr("name"));
			$(this).attr("name", Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10));
		}
	})
};

$.fn.decryptFieldNames = function(){
	$(this).find("input").each(function(){
		if($(this).data("original-name") != null){
			$(this).attr("name", $(this).data("original-name"));
			$(this).data("original-name", null);
		}
	})
};

$.fn.validForm = function(onValid){
	if(onValid === undefined) onValid = function(){};
	var that = this;
	if($(that).valid()){
		onValid(function(success){
			if(!success){
				toastr.error("Il y a des erreurs dans le formulaire. Veuillez reviser les informations inscrites.")
			}
			else{
        window.toggleWarn(false);
				toastr.options.positionClass = 'toast-bottom-right';
				toastr.success("Données enregistrées avec succès!")
			}
		});
	}
	else{
		toastr.error("Il y a des erreurs dans le formulaire. Veuillez reviser les informations inscrites.")
	}

}

window.createAppointmentFromPopup = function(data, callback){
	if (callback === undefined) callback = function(success){};
	var message_text = "<h1>Enregistrement...<br>Veuillez patienter</h1>";
	App.blockUI({ message: message_text, boxed: true, zIndex: 20000 });

	$.ajax({
		url: window.baseUrl + "appointment/add/save",
		type: "POST",
		data: {
			form: data,
			filters: {
				filter_page: 1,
				filter_order_orientation: "ASC",
				filter_order_column: "appointment_date",
				filter_by_page: 25,
				filter_appointment_completed: 0
			}
		},
		dataType: "html"
	}).done(function(){
		App.unblockUI();
		callback(true);
	}).fail(function(jqXHR, textStatus, thrownErr){
		App.unblockUI();
		processXHRError(jqXHR, textStatus, thrownErr);
		callback(false);
		console.log("Request createAppointmentFromPopup failed: " + textStatus);
	});
}

window.openAppointmentCreatePopup = function(prefill, onCreated){
	if (prefill === undefined || prefill === null) prefill = {};
	if (onCreated === undefined) onCreated = function(){};

	var message_text = "<h1>Traitement...<br>Veuillez patienter</h1>";
	App.blockUI({ message: message_text, boxed: true, zIndex: 20000 });

	$.ajax({
		url: window.baseUrl + "appointment/add",
		type: "POST",
		data: { prefill: prefill },
		dataType: "html"
	}).done(function(msg){
		App.unblockUI();
		var popup = bootbox.dialog({
			message: msg,
			title: "Ajout d'un rappel",
			className: "modal-appointment",
			size: "medium",
			buttons: {
				save: {
					label: "Enregistrer",
					className: "purple",
					callback: function(){
						$("#form_appointment").validForm(function(onSuccess){
							createAppointmentFromPopup($("#form_appointment").serialize(), function(success){
								processPopupServerResponse(popup, success);
								onSuccess(success);
								if (success) {
									onCreated();
								}
							});
						});
						return false;
					}
				},
				cancel: {
					label: "Annuler",
					className: "btn",
					callback: function(){}
				}
			}
		});
	}).fail(function(jqXHR, textStatus, thrownErr){
		App.unblockUI();
		processXHRError(jqXHR, textStatus, thrownErr);
		console.log("Request openAppointmentCreatePopup failed: " + textStatus);
	});
}

$(document).off("click", ".action-add-appointment-context");
$(document).on("click", ".action-add-appointment-context", function(){
	var prefill = {
		customer_id: parseInt($(this).attr("data-appointment-customer-id") || 0, 10) || 0,
		quote_id: parseInt($(this).attr("data-appointment-quote-id") || 0, 10) || 0,
		invoice_id: parseInt($(this).attr("data-appointment-invoice-id") || 0, 10) || 0,
		customer_name: $(this).attr("data-appointment-customer-name") || ""
	};

	openAppointmentCreatePopup(prefill);
});

$(document).off("click", ".action-edit-appointment-context");
$(document).on("click", ".action-edit-appointment-context", function(){
	var id = parseInt($(this).attr("data-appointment-id") || 0, 10);
	if (id > 0) {
		openAppointmentEditPopupContext(id);
	}
});

window.openAppointmentEditPopupContext = function(id) {
	var message_text = "<h1>Chargement...<br>Veuillez patienter</h1>";
	App.blockUI({ message: message_text, boxed: true, zIndex: 20000 });

	$.ajax({
		url: window.baseUrl + "appointment/edit",
		type: "POST",
		data: { id: id },
		dataType: "html"
	}).done(function(msg) {
		App.unblockUI();
		var popup = bootbox.dialog({
			message: msg,
			title: "Modification du rappel",
			className: "modal-appointment",
			size: "medium",
			buttons: {
				save: {
					label: "Sauvegarder",
					className: "purple",
					callback: function() {
						if ($("#form_appointment").valid()) {
							App.blockUI({ message: "<h1>Sauvegarde...<br>Veuillez patienter</h1>", boxed: true, zIndex: 20000 });
							$.ajax({
								url: window.baseUrl + "appointment/edit/save",
								type: "POST",
								data: { form: $("#form_appointment").serialize(), id: id, from: "context" },
								dataType: "json"
							}).done(function() {
								App.unblockUI();
								popup.modal("hide");
								toastr.success("Rappel modifié avec succès.");
							}).fail(function(jqXHR, textStatus, thrownErr) {
								App.unblockUI();
								processXHRError(jqXHR, textStatus, thrownErr);
							});
						}
						return false;
					}
				},
				cancel: {
					label: "Annuler",
					className: "btn",
					callback: function() {}
				}
			}
		});
	}).fail(function(jqXHR, textStatus, thrownErr) {
		App.unblockUI();
		processXHRError(jqXHR, textStatus, thrownErr);
	});
};